document.addEventListener("DOMContentLoaded", function () {
    var productGrids = document.querySelectorAll(".grid.product-grid");

    productGrids.forEach(function (productGrid) {
        var sectionId = productGrid.getAttribute("data-section-id");
        var variantDataMap = window["variantDataMap" + sectionId.replace(/-/g, "_")];

        productGrid.addEventListener("change", function (e) {
            if (e.target.matches(`input[type="radio"][data-section-id="${sectionId}"]`)) {
                var card = e.target.closest(`.card-product-custom-div[data-section-id="${sectionId}"]`);
                var variantId = e.target.getAttribute("data-variant-id");
                var variantData = variantDataMap[variantId];

                if (!variantData) {
                    console.warn("No data found for variant:", variantId);
                    return;
                }

                // ✅ Show image instantly (without delay)
                updateImage(card, variantData.imageUrl);

                // ✅ Preload optimized 533px image & swap it after loading
                preloadImage(variantData.imageUrl + "&width=533", function () {
                    updateImage(card, variantData.imageUrl + "&width=533");
                });

                // ✅ Preload hover image (if exists)
                if (variantData.hoverImgUrl) {
                    preloadImage(variantData.hoverImgUrl + "&width=533");
                }
            }
        });
    });

    // 🔹 Function to preload image
    function preloadImage(url, callback) {
        var img = new Image();
        img.src = url;
        img.onload = function () {
            if (typeof callback === "function") {
                callback();
            }
        };
    }

    // 🔹 Function to update image immediately
    function updateImage(card, imageUrl) {
        var productImageElement = card.querySelector(".card__media img");
        if (productImageElement) {
            productImageElement.src = imageUrl;
            productImageElement.srcset = imageUrl + " 533w";
        }

        var productImageElementCover = card.querySelector(".card__media .hover-cover");
        if (productImageElementCover) {
            productImageElementCover.src = imageUrl;
            productImageElementCover.srcset = imageUrl + " 533w";
        }
    }
});
